import { IconButtonProps } from '@mui/material/IconButton';
import React, { forwardRef } from 'react';
import { IconActionButtonRoot } from './IconActionButton.styles';

export const IconActionButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconActionButtonRoot ref={ref} {...props} />
));

IconActionButton.displayName = 'IconActionButton';
